import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Badge from '@mui/material/Badge';

// Shared with the per-step markers on the Setup Assistant page
// (SetupStepRow), so the two badges cannot drift apart.
export const SETUP_ASSISTANT_BADGE_SX = {
  '& .MuiBadge-badge':
  {
    fontSize: '10px',
    width: '15px',
    minWidth: '15px',
    height: '15px',
  },
};

/**
 * SetupAssistantBadge — the count of verifiable Setup Assistant steps still
 * to do, on the sidebar entry. Modeled on ChatBage.jsx.
 *
 * Reads only: the count lives in state.setupAssistant and is refreshed by
 * NavBar (mount, route change) and the Setup Assistant page (after each
 * write). Hidden when the count is 0, null, or not loaded yet, and until
 * the server says showBadges (the account is past its default-screen phase).
 */
function SetupAssistantBadge({ children, className }) {
  const { outstandingCount, showBadges } = useSelector((state) => state?.setupAssistant || {});
  const isVisible = showBadges === true
    && Number.isInteger(outstandingCount)
    && outstandingCount > 0;

  return (
    <Badge
      className={className}
      badgeContent={isVisible ? outstandingCount : 0}
      invisible={!isVisible}
      color="secondary"
      sx={SETUP_ASSISTANT_BADGE_SX}
    >
      {children}
    </Badge>
  );
}

SetupAssistantBadge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default SetupAssistantBadge;
